import { initializeUser, getUserProfile, updateLastActive } from './firestore';

/**
 * Generate a unique user ID
 */
export function generateUserId(): string {
  return crypto.randomUUID();
}

/**
 * Get user ID from localStorage or create a new one
 */
export function getUserId(): string {
  const STORAGE_KEY = 'deepcheck-user-id';

  let userId = localStorage.getItem(STORAGE_KEY);

  if (!userId) {
    userId = generateUserId();
    localStorage.setItem(STORAGE_KEY, userId);

    // Initialize user in Firestore
    initializeUser(userId).catch((error) => {
      console.error('Failed to initialize user in Firestore:', error);
    });
  }

  return userId;
}

/**
 * Initialize user session
 * Call this when the app loads
 */
export async function initializeUserSession(): Promise<string> {
  const userId = getUserId();

  try {
    // Check if user exists in Firestore, if not create
    const profile = await getUserProfile(userId);

    if (!profile) {
      await initializeUser(userId);
    } else {
      // Update last active timestamp
      await updateLastActive(userId);
    }

    return userId;
  } catch (error) {
    console.error('Error initializing user session:', error);
    return userId;
  }
}
